module.exports = __webpack_public_path__ + "static/media/chain-secure.0929c9ac.svg";